export type { CacheConfig, CacheStats, CacheEntry, MemoryCacheEntry } from './cache.types.ts';
export { CacheManager } from './cache-manager.ts';
export { generateCacheKey } from './cache-key.ts';
export {
  DASHBOARD_TTL_MS,
  ADMIN_TTL_MS,
  AGRO_DASHBOARD_TTL_MS,
  AGRO_DASHBOARD_DATA_TTL_MS,
  TRAZABILIDAD_TTL_MS,
  TABLE_PAGE_TTL_MS,
  VIGILANCIA_TTL_MS,
  DEVICES_DASHBOARD_TTL_MS,
  DEFAULT_TABLE_TTL_MS,
} from './page-cache-config.ts';

import { CacheManager } from './cache-manager.ts';
import type { CacheConfig } from './cache.types.ts';

// ──── Singleton ────

let instance: CacheManager | null = null;

export function getCacheManager(config?: Partial<CacheConfig>): CacheManager {
  if (!instance) {
    const isLocal =
      typeof window !== 'undefined' &&
      (window.location.hostname === 'localhost' ||
        window.location.hostname === '127.0.0.1');

    instance = new CacheManager({
      enableLogging: isLocal,
      ...config,
    });
  }
  return instance;
}

export function destroyCacheManager(): void {
  if (instance) {
    instance.destroy();
    instance = null;
  }
}
